<template>
  <base-window-list
    :headers="headers"
    title="Listado de Tipo de Ajustes "
    :company="comdes"
    addMethod="itemsTipoAjuste"
    closeBaseWindow='addTipoAjuste'
    titleAddMethod="Agregar Tipo de Ajustes "
    itemStoreName="itemsTipoAjuste"
    :loading="loadingResult"
    :activarEdicion="true"
    :activarBorrar="true"
    :activarInternalForm="true"
    :formProperties="{
      creacion: 'Creacion de Tipo de Ajustes ',
      edicion: 'Editar Tipo de Ajustes ',
      url: `/transjuma/TipoAjuste/`
    }"
    v-on:selected-row="handleEvent"
    v-on:updated="updatedList"
  >
    <template v-slot:item.valor_adicional="{item}">
      <td class="text-end">{{ $convertToMoney(item.valor_adicional) }}</td>
    </template>
  
  </base-window-list>
</template>

<script>
import { mapState } from 'vuex'
import BaseWindowList from '@/components/BaseWindowListGeneral'
import { paginationMethods } from '@/mixins/pagination'
export default {
  components:{
    BaseWindowList
  },
  mixins: [paginationMethods],
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          colmd: 4,
          form: false,
          require: true,
          vtext: true,
        },
        {
          text: 'Nombre',
          align: 'center',
          value: 'nombre',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Valor Adicional',
          align: 'end',
          value: 'valor_adicional',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Descripcion Detallada',
          align: 'center',
          value: 'descripcion_detallada',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Acciones',
          align: 'center',
          value: 'actions',
          require: true,
        },
      ],
      loadingResult: true
    }
  },
  computed:{
    ...mapState([
      'addTipoAjuste',
    ]),
    company(){
      return this.$store.state.AuthModule.refu
    },
    comdes(){
      return 'Transjuma'
    }
  },
  methods: {
    handleEvent(item) {
      this.$emit('TipoAjuste-selected', item)
    },
    updatedList(){
      this.$store.dispatch('clearCatalog', 'tipoAjustes')
      this.getData()
    },
    async getData(){
      await this.$store.dispatch('AuthModule/verifyToken')
      console.log('BUSCANDO LOS DATOS')
      const obj = {
        token : this.$store.state.AuthModule.accessToken,
        method: 'GET',
        url: 'transjuma/TipoAjuste/',
        // body: body
        params:{
          ids: 1
        }
      }
      // this.loadingTable = true
      this.$store.dispatch('fechData', obj)
        .then((result) => {
          this.$store.dispatch('actItemsBaseWindowsList',{data: result, nombre: 'itemsTipoAjuste'})
          this.loadingResult = false
        })
        .catch((err) => {
          const regex = /["[{\]}]/g
          const mensaje = JSON.stringify(err.response.data).replaceAll(regex,'') ?? ''
          this.showAlert('error', mensaje)
          this.loadingResult = false
          if (err.response.status == 401){
            alert(
              `token no valido o vencido:  ${err.response.data.detail ?? ''}`
            )
            this.$router.push({name: 'LoginView'})
          }
        })
    }
  },
  created() {
    this.$store.state.itemsTipoAjuste = []
    this.getData()
  }
}
</script>

<style>

</style>